/* eslint-disable react/display-name */
import {
  Button,
  Col,
  ContentBody,
  ContentHeader,
  Input,
  Row,
  Select,
  Table,
  Drawer
} from '../../core/components'
import { Link } from 'react-router-dom'
import { routesConfig } from '../../core/configs/routes'
import { FilterOutlined, PlusOutlined } from '@ant-design/icons'
import { formatCnpjCpf } from '../../core/utils'
import { Checkbox, Select as AntdSelect, Tag, Typography } from 'antd'
import { ChangeEvent, useEffect, useState } from 'react'
import { City, CustomersFilter } from '../../entities'
import { State } from '../../entities/state'
import useCustomers from '../../services/queries/customer/useCustomers'
import useStates from '../../services/queries/useStates'
import useCities from '../../services/queries/useCities'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'

const { Option } = AntdSelect
export const CustomersPage = () => {
  const [pagination, setPagination] = useState<{ page: number; limit: number }>(
    { page: 1, limit: 10 }
  )
  const [showFilter, setShowFiler] = useState<boolean>(false)
  const [filters, setFilters] = useState<CustomersFilter>({
    search: '',
    state: '',
    city: '',
    contract: false
    // sellerId: user?.user?.id || ''
  })
  const [filterState, setFilterState] = useState<CustomersFilter>({
    search: '',
    state: '',
    city: '',
    contract: false
    // sellerId: user?.user?.id || ''
  })

  console.log(filterState?.contract)
  console.log(filters?.contract)

  const { data, isLoading, isFetching, isPreviousData } = useCustomers({
    ...pagination,
    filters
  })
  const { data: states, isLoading: isStatesLoading } = useStates()
  const { data: cities, isLoading: isCitiesLoading } = useCities({
    page: 1,
    limit: 9999,
    filters: { state: filterState?.state }
  })
  const columns = [
    {
      title: 'Código',
      dataIndex: 'id',
      key: 'id',
      render: (value: any, row: any) => {
        return (
          <Link to={routesConfig.customers.customer.details + `/${row.id}`}>
            {value}
          </Link>
        )
      }
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, row: any) => (
        <Row>
          <Col span={12}>
            <Typography>{text}</Typography>
          </Col>
          <Col span={12}>
            <Tag
              style={{ fontSize: '11px' }}
              visible={row?.default}
              color="red"
            >
              INADIMPLENTE
            </Tag>
          </Col>
        </Row>
        // <div style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
        //   <div>
        //     <Typography>{text}</Typography>
        //   </div>
        //   <Tag style={{ fontSize: '11px' }} visible={row?.default} color="red">
        //     INADIMPLENTE
        //   </Tag>
        // </div>
      )
    },
    {
      title: 'Fantasia/Apelido',
      dataIndex: 'nickname',
      key: 'nickname'
    },
    {
      title: 'CNPJ/CPF',
      dataIndex: 'employerNumber',
      key: 'employerNumber',
      render: (text: any) => formatCnpjCpf(text)
    },
    {
      title: 'Município',
      dataIndex: 'city',
      key: 'city'
    },
    {
      title: 'UF',
      dataIndex: 'state',
      key: 'state'
    }
  ]

  const handleShowFilter = () => {
    setShowFiler((prev: boolean) => !prev)
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterState((prev: CustomersFilter) => ({
      ...prev,
      search: e.target.value.toUpperCase()
    }))
  }

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const onSearch = (value: any) => {
    return value
  }

  const handleStateClear = () => {
    setFilterState((prev) => ({ ...prev, state: '', city: '' }))
    setFilters((prev) => ({ ...prev, state: '', city: '' }))
  }

  const handleCityClear = () => {
    setFilterState((prev) => ({ ...prev, city: '' }))
    setFilters((prev) => ({ ...prev, city: '' }))
  }

  const handleReset = () => {
    setFilterState({ search: '', state: '', city: '', contract: false })
    setFilters({ search: '', state: '', city: '', contract: false })
  }

  useEffect(() => {
    if (filterState.search === '')
      setFilters((prev) => ({ ...prev, search: '' }))
  }, [filterState.search])

  return (
    <>
      <ContentHeader>Clientes</ContentHeader>
      <ContentBody>
        <Link to={routesConfig.customers.customer.create}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            style={{
              marginBottom: 30
            }}
          >
            Novo
          </Button>
        </Link>
        <Row>
          <Col>
            <Input
              allowClear
              value={filterState.search}
              placeholder="Pesquisar por Código, Nome, Fantasia, CNPJ..."
              style={{ width: '385px', marginBottom: 20, marginRight: 20 }}
              onChange={(e) => handleSearch(e)}
              onPressEnter={() => setFilters(filterState)}
            />
          </Col>
          <Col>
            <Button
              htmlType="submit"
              type="primary"
              style={{ width: 100 }}
              onClick={() => setFilters(filterState)}
            >
              Procurar
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={handleShowFilter}
              icon={<FilterOutlined />}
            >
              Filtros
            </Button>
          </Col>
        </Row>
        <div style={{ marginBottom: 10 }}>
          <a>
            {Object.entries(filterState).reduce(
              (acc: any, cur: any) => !!cur[1] && acc++,
              0
            ) || 0}{' '}
            Filtros selecionados
          </a>
        </div>
        <Table
          loading={(isLoading || isFetching) && isPreviousData}
          dataSource={data?.data}
          columns={columns}
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
          bordered
          rowKey={(row) => row.id}
        />

        <Drawer
          title="Filtros"
          width={520}
          closable={false}
          onClose={handleShowFilter}
          visible={showFilter}
          footer={
            <div
              style={{
                textAlign: 'right',
                paddingBottom: 30,
                paddingTop: 30
              }}
            >
              <Button
                onClick={() => {
                  handleReset()
                  handleShowFilter()
                }}
                style={{ marginRight: 8 }}
              >
                Reiniciar
              </Button>
              <Button
                onClick={() => {
                  setFilters(filterState)
                  handleShowFilter()
                }}
                type="primary"
              >
                Aplicar
              </Button>
            </div>
          }
        >
          <div>
            <Row>
              <Col span={24}>
                <Select
                  label="Estado"
                  placeholder="Estado"
                  showSearch
                  onSearch={onSearch}
                  loading={isStatesLoading}
                  allowClear
                  onClear={handleStateClear}
                  value={filterState.state || null}
                  filterOption={(input, option) => {
                    if (typeof option?.children === 'string') {
                      return (
                        option?.children
                          ?.toUpperCase()
                          .indexOf(input.toUpperCase()) >= 0
                      )
                    }
                    return false
                  }}
                  onSelect={(state: string) =>
                    setFilterState((prev: CustomersFilter) => ({
                      ...prev,
                      state,
                      city: ''
                    }))
                  }
                >
                  {states?.data?.map((state: State) => (
                    <Option key={state.id} value={state.id}>
                      {`${state.id} - ${state.name}`}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Select
                  label="Cidade"
                  showSearch
                  onSearch={onSearch}
                  loading={isCitiesLoading}
                  allowClear
                  onClear={handleCityClear}
                  placeholder="Munícipio"
                  value={filterState.city || null}
                  filterOption={(input, option) =>
                    option?.children
                      .toUpperCase()
                      .indexOf(input.toUpperCase()) >= 0
                  }
                  onSelect={(city: string) =>
                    setFilterState((prev: CustomersFilter) => ({
                      ...prev,
                      city
                    }))
                  }
                >
                  {cities?.data?.map((city: City) => (
                    <Option key={city.id} value={city.id}>
                      {city.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Checkbox
                  onChange={(contract: CheckboxChangeEvent) =>
                    setFilterState((prev: CustomersFilter) => ({
                      ...prev,
                      contract: contract.target.checked
                    }))
                  }
                >
                  Com contrato
                </Checkbox>
              </Col>
            </Row>
          </div>
        </Drawer>
      </ContentBody>
    </>
  )
}
